export default "__VITE_ASSET__DoDk6hcs__"